import { useBuyOffer as u } from "../../../pages/checkout/api/index.mjs";
const y = () => {
  const { buyOffer: r, isFetching: e } = u();
  return {
    razorpayBuyOffer: (f, o) => r(f, o),
    isFetching: e
  };
};
export {
  y as useRazorpayBuyOffer
};
